// HeroBanner.tsx
import React from "react";

export default function HeroBanner({
  bgImage,
  title = "Welcome to Rankridge School, Hyderabad",
  subtitle = "Admissions Open 2026–27 | Rankridge Schools – A Complete Journey from Pre-School to Grade 12 with Academic Excellence, Personal Mentorship, Leadership Programs, Arts, Culture & Global Careers",
  tintHex = "#20b2aa",
}) {
  return (
    <section
      className="relative  w-full mt-4 grid place-items-center overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.20), rgba(231, 223, 223, 0.2)), url('${bgImage}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Curved decorative overlay (SVG) */}
      <svg
        className="pointer-events-none absolute inset-0 w-full h-full"
        viewBox="0 0 1440 900"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        {/* Left curve */}
        <path
          d="M-50,0 C120,200 160,420 90,620 C30,790 0,900 0,900 L0,0 Z"
          fill={tintHex}
          opacity="0.25"
        />
        {/* Right curve */}
        <path
          d="M1440,0 L1440,900 C1180,850 1110,680 1160,520 C1210,360 1360,220 1440,160 L1440,0 Z"
          fill={tintHex}
          opacity="0.25"
        />
      </svg>

      {/* Content card */}
      <div className="relative mx-4 sm:mx-6 md:mx-10 max-w-4xl  bg-white rounded-2xl">
        <div className="rounded-3xl bg-white/15 backdrop-blur-md ring-1 ring-white/30 px-6 sm:px-10 py-8 sm:py-10">
          <h1 className=" text-[#20b2aa] text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight">
            {title}
          </h1>
          <p className="mt-4 text-black text-base sm:text-lg leading-relaxed">
            {subtitle}
          </p>

          {/* CTA row (optional) */}
          {/* <div className="mt-6 flex flex-wrap items-center gap-3">
            <a
              href="#admissions"
              className="inline-flex items-center rounded-full px-5 py-3 text-sm font-semibold text-white"
              style={{ backgroundColor: tintHex }}
            >
              Apply for Admission
            </a>
            <a
              href="#contact"
              className="inline-flex items-center rounded-full px-5 py-3 text-sm font-semibold bg-white/80 text-gray-900 hover:bg-white"
            >
              Contact Us
            </a>
          </div> */}
        </div>
      </div>
    </section>
  );
}
